import { Button, Result } from 'antd'
import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLanguageContext } from '../contexts/LanguageContext'

const OfflinePage: FC<{ children?: React.ReactNode }> = ({ children }) => {
	const { t } = useTranslation()
	const { currentLanguage } = useLanguageContext()

	// Update HTML lang attribute when language changes
	useEffect(() => {
		document.documentElement.setAttribute('lang', currentLanguage)
	}, [currentLanguage])

	return (
		<>
			{!navigator.onLine ? (
				<div className={'h-100% flex justify-center items-center m-4'}>
					<Result
						title={'Offline'}
						subTitle={t('loc:general:Offline description')}
						extra={
							<Button type={'primary'} shape={'round'} onClick={() => window.location.reload()}>
								{t('loc:general:Refresh')}
							</Button>
						}
					/>
				</div>
			) : (
				children
			)}
		</>
	)
}

export default OfflinePage
